import z from 'zod';

const paymentMethodSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('pix')
  }),
  z.object({
    type: z.literal('credit_card'),
    cardInfo: z.string()
  }),
  z.object({
    type: z.literal('bankslip')
  })
]);

export const myEduzzProductPayloadSchema = z.object({
  info: z.array(
    z.object({
      locale: z.string(),
      title: z.string(),
      description: z.string()
    })
  ),
  categories: z.array(z.number()),
  image: z.url(),
  supportEmailAddress: z.email(),
  isDraft: z.boolean(),
  friendlyName: z.string(),
  type: z.enum(['digital', 'physical']),
  payment: z.object({
    type: z.enum(['oneTime', 'free', 'subscription', 'open']),
    price: z.array(
      z.object({
        currency: z.string(),
        value: z.number()
      })
    ),
    methods: z.array(paymentMethodSchema)
  }),
  features: z.array(
    z.object({
      feature: z.enum([
        'sales_recovery',
        'multiple_cards',
        'combined_payment',
        'installments_without_limitation',
        'installments_without_interest'
      ])
    })
  ),
  deliverables: z.array(
    z.object({
      url: z.url(),
      path: z.string(),
      name: z.string(),
      type: z.string(),
      size: z.number()
    })
  )
});

export type myEduzzProductPayloadType = z.infer<typeof myEduzzProductPayloadSchema>;

export const myEduzzProductResponseSchema = z.union([
  z.object({
    status: z.literal(201),
    data: z.object({
      id: z.number(),
      hash: z.string(),
      checkoutUrl: z.url(),
      checkoutElementsUrl: z.url()
    })
  }),
  z.object({
    status: z.literal(409),
    data: z.object({
      error: z.object({
        title: z.string().optional(),
        description: z.string().optional()
      })
    })
  }),
  z
    .object({
      status: z.number(),
      data: z.any()
    })
    .refine(obj => {
      console.log('Unexpected response status:', obj.status);
      console.log('Unexpected response data:', obj.data);
    })
]);

export type myEduzzProductResponseType = z.infer<typeof myEduzzProductResponseSchema>;

export const producerDataValidator = z.object({
  producerNative: z.boolean(),
  producerDocument: z.string().nonempty(),
  producerZipCode: z.string().nonempty(),
  producerCity: z.string().nonempty(),
  producerCityId: z.string().nonempty(),
  producerState: z.string().nonempty(),
  producerStreetName: z.string().nonempty(),
  producerStreetNumber: z.string().nonempty(),
  producerDistrict: z.string().nonempty(),
  producerComplement: z.string().optional(),
  producerCellPhone: z.string().nonempty(),
  producerFiscalTerm: z.boolean(),
  producerUseTerm: z.boolean()
});

export type ProducerData = z.infer<typeof producerDataValidator>;
